import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Button } from 'react-bootstrap';
import { FaDownload, FaPrint, FaTimes } from 'react-icons/fa';

const SinglePaymentReceipt = () => {
  const [clinic, setClinic] = useState(null);
  const [receiptData, setReceiptData] = useState(null);
  
  useEffect(() => {
    const data = sessionStorage.getItem('singlePaymentReceipt');
    if (data) {
      setReceiptData(JSON.parse(data));
    }
    
    axios.get('/api/clinic.php')
      .then(res => setClinic(res.data))
      .catch(err => console.error(err));
  }, []);

  const formatCurrency = (amount) => {
    return parseFloat(amount || 0).toLocaleString('en-PK', {
      style: 'currency',
      currency: 'PKR'
    });
  };

  const handleDownloadPDF = () => {
    const element = document.getElementById('receipt-content');
    const opt = {
      margin: 5,
      filename: `Payment_Receipt_${payment?.id || Date.now()}.pdf`,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
      pagebreak: { mode: 'avoid-all' }
    };
    import('html2pdf.js').then(html2pdf => {
      html2pdf.default().set(opt).from(element).save();
    });
  };

  if (!receiptData || !clinic) {
    return <div style={{ padding: '50px', textAlign: 'center' }}><h4>Loading...</h4></div>;
  }

  const { payment, billings, doctorName } = receiptData;
  const totalCollected = payment?.totalCollected || (billings && billings.length > 0 ? billings.reduce((sum, b) => sum + parseFloat(b.paidAmount || 0), 0) : payment?.amountCollected || 0);
  const totalTransferred = payment?.totalTransferred || payment?.amountTransferred || 0;

  return (
    <div>
      <style>{`
        @media print {
          @page { size: A4; margin: 0; }
          body * { visibility: hidden; }
          #receipt-content, #receipt-content * { visibility: visible; }
          #receipt-content { position: absolute; left: 0; top: 0; width: 100%; margin: 0; padding: 10mm; box-sizing: border-box; }
          * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
          .page-header { display: table-header-group; }
          .page-footer { display: table-footer-group; }
          thead { display: table-header-group; }
          tr { page-break-inside: avoid; }
        }
      `}</style>
      
      <div className="no-print" style={{ padding: '20px', backgroundColor: '#f5f5f5' }}>
        <div style={{ textAlign: 'right', marginBottom: '10px' }}>
          <Button variant="success" className="me-2" onClick={() => window.print()}>
            <FaPrint className="me-2" /> Print
          </Button>
          <Button variant="primary" className="me-2" onClick={handleDownloadPDF}>
            <FaDownload className="me-2" /> Download PDF
          </Button>
          <Button variant="secondary" onClick={() => window.close()}>
            <FaTimes className="me-2" /> Close
          </Button>
        </div>
      </div>

      <div id="receipt-content" style={{ width: '100%', margin: '0', backgroundColor: 'white', padding: '10mm', fontSize: '12px' }}>
        
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead className="page-header">
            <tr>
              <td>
                <div style={{ textAlign: 'center', borderBottom: '2px solid #333', paddingBottom: '10px', marginBottom: '15px' }}>
                  {clinic.logo && <img src={`${window.location.origin}${clinic.logo}`} alt="Logo" style={{ maxWidth: '60px', marginBottom: '5px' }} />}
                  <h2 style={{ margin: '5px 0', fontSize: '20px', color: '#1565c0' }}>{clinic.name}</h2>
                  <p style={{ margin: '3px 0', fontSize: '11px' }}>{clinic.address}</p>
                  <p style={{ margin: '3px 0', fontSize: '11px' }}>Contact: {clinic.contactNumber}</p>
                  <h3 style={{ textAlign: 'center', margin: '10px 0', fontSize: '16px' }}>Payment Transfer Receipt</h3>
                </div>
              </td>
            </tr>
          </thead>
          
          <tbody>
            <tr>
              <td style={{ padding: 0 }}>
                <div>

        <div style={{ marginBottom: '15px', padding: '8px', backgroundColor: '#f5f5f5' }}>
          <p style={{ margin: '3px 0', fontSize: '11px' }}><strong>Transfer Date:</strong> {new Date(payment.transferDate).toLocaleDateString()}</p>
          <p style={{ margin: '3px 0', fontSize: '11px' }}><strong>Doctor:</strong> {doctorName}</p>
          <p style={{ margin: '3px 0', fontSize: '11px' }}><strong>Collection Date:</strong> {new Date(payment.transferDate).toLocaleDateString()}</p>
          {payment.payments && payment.payments.length > 0 && (
            <p style={{ margin: '3px 0', fontSize: '11px' }}><strong>Number of Transfers:</strong> {payment.payments.length}</p>
          )}
        </div>

        {payment.payments && payment.payments.length > 0 && (
          <div style={{ marginBottom: '15px' }}>
            <h4 style={{ borderBottom: '1px solid #ddd', paddingBottom: '5px', marginBottom: '8px', fontSize: '14px' }}>Transfer Details</h4>
            <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #ddd' }}>
              <thead>
                <tr style={{ backgroundColor: '#f8f9fa' }}>
                  <th style={{ border: '1px solid #ddd', padding: '5px', textAlign: 'left', fontSize: '11px' }}>Time</th>
                  <th style={{ border: '1px solid #ddd', padding: '5px', textAlign: 'right', fontSize: '11px' }}>Transferred</th>
                  <th style={{ border: '1px solid #ddd', padding: '5px', textAlign: 'left', fontSize: '11px' }}>Received By</th>
                  <th style={{ border: '1px solid #ddd', padding: '5px', textAlign: 'left', fontSize: '11px' }}>Notes</th>
                </tr>
              </thead>
              <tbody>
                {payment.payments.map((p, index) => (
                  <tr key={p.id} style={{ backgroundColor: index % 2 === 0 ? '#fff' : '#f9f9f9' }}>
                    <td style={{ border: '1px solid #ddd', padding: '4px', fontSize: '10px' }}>{new Date(p.transferDate).toLocaleTimeString()}</td>
                    <td style={{ border: '1px solid #ddd', padding: '4px', textAlign: 'right', fontWeight: 'bold', fontSize: '10px' }}>{formatCurrency(p.amountTransferred)}</td>
                    <td style={{ border: '1px solid #ddd', padding: '4px', fontSize: '10px' }}>{p.receivedBy || '-'}</td>
                    <td style={{ border: '1px solid #ddd', padding: '4px', fontSize: '10px' }}>{p.notes || '-'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        <div style={{ marginBottom: '15px' }}>
          <h4 style={{ borderBottom: '1px solid #ddd', paddingBottom: '5px', marginBottom: '8px', fontSize: '14px' }}>Payment Summary</h4>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <tbody>
              <tr style={{ borderBottom: '1px solid #ddd' }}>
                <td style={{ padding: '6px', fontWeight: 'bold', fontSize: '11px' }}>Amount Collected (This Period):</td>
                <td style={{ padding: '6px', textAlign: 'right', color: '#28a745', fontWeight: 'bold', fontSize: '11px' }}>{formatCurrency(totalCollected)}</td>
              </tr>
              <tr style={{ borderBottom: '1px solid #ddd' }}>
                <td style={{ padding: '6px', fontWeight: 'bold', fontSize: '11px' }}>Total Transferred to Owner:</td>
                <td style={{ padding: '6px', textAlign: 'right', color: '#007bff', fontWeight: 'bold', fontSize: '11px' }}>{formatCurrency(totalTransferred)}</td>
              </tr>
              <tr style={{ borderBottom: '1px solid #ddd' }}>
                <td style={{ padding: '6px', fontWeight: 'bold', fontSize: '11px' }}>Remaining with Doctor:</td>
                <td style={{ padding: '6px', textAlign: 'right', color: '#ffc107', fontWeight: 'bold', fontSize: '11px' }}>{formatCurrency(totalCollected - totalTransferred)}</td>
              </tr>
            </tbody>
          </table>
        </div>

        {billings && billings.length > 0 && (
          <div>
            <h4 style={{ borderBottom: '1px solid #ddd', paddingBottom: '5px', marginBottom: '8px', fontSize: '14px' }}>Billing Transactions</h4>
            <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #ddd' }}>
              <thead>
                <tr style={{ backgroundColor: '#f8f9fa' }}>
                  <th style={{ border: '1px solid #ddd', padding: '5px', textAlign: 'left', fontSize: '11px' }}>Date</th>
                  <th style={{ border: '1px solid #ddd', padding: '5px', textAlign: 'left', fontSize: '11px' }}>Patient</th>
                  <th style={{ border: '1px solid #ddd', padding: '5px', textAlign: 'right', fontSize: '11px' }}>Total</th>
                  <th style={{ border: '1px solid #ddd', padding: '5px', textAlign: 'right', fontSize: '11px' }}>Paid</th>
                  <th style={{ border: '1px solid #ddd', padding: '5px', textAlign: 'left', fontSize: '11px' }}>Method</th>
                </tr>
              </thead>
              <tbody>
                {billings.map((bill, index) => (
                  <tr key={bill.id} style={{ backgroundColor: index % 2 === 0 ? '#fff' : '#f9f9f9' }}>
                    <td style={{ border: '1px solid #ddd', padding: '4px', fontSize: '10px' }}>{new Date(bill.billDate).toLocaleDateString()}</td>
                    <td style={{ border: '1px solid #ddd', padding: '4px', fontSize: '10px' }}>{bill.patientName}</td>
                    <td style={{ border: '1px solid #ddd', padding: '4px', textAlign: 'right', fontSize: '10px' }}>{formatCurrency(bill.totalAmount)}</td>
                    <td style={{ border: '1px solid #ddd', padding: '4px', textAlign: 'right', fontWeight: 'bold', fontSize: '10px' }}>{formatCurrency(bill.paidAmount)}</td>
                    <td style={{ border: '1px solid #ddd', padding: '4px', fontSize: '10px' }}>{bill.paymentMethod || '-'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

                </div>
              </td>
            </tr>
          </tbody>
          
          <tfoot className="page-footer">
            <tr>
              <td>
                <div style={{ paddingTop: '8px', borderTop: '1px solid #ddd', textAlign: 'center', fontSize: '10px' }}>
                  <p style={{ margin: '3px 0' }}>This is a computer-generated receipt</p>
                  <p style={{ margin: '3px 0' }}>Designed by Abdullah Arif | Contact: +92-3137323866</p>
                </div>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
};

export default SinglePaymentReceipt;
